<template>
  <div id="container">
    <div id="content">
      <div id="title">
        <svg id="pressor-button" viewBox="0 0 126 80">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g>
              <path
                d="M92.5623482,0.5 L33.4405075,0.5 C32.6816973,0.5 31.9639561,0.844637189 31.4894924,1.43681726 L1.89086054,38.3789962 C1.52530354,38.8352495 1.34228509,39.3877219 1.34187628,39.9403295 C1.34146746,40.492937 1.52366828,41.0456797 1.8885498,41.5024733 L31.4899138,78.5602943 C31.9643102,79.1541891 32.6831323,79.5 33.4432396,79.5 L92.5596163,79.5 C93.3183677,79.5 94.0360599,79.155416 94.5105265,78.5633136 L124.205889,41.505498 C124.572382,41.0481391 124.755388,40.4941685 124.754978,39.9403337 C124.754568,39.3864989 124.570742,38.8327999 124.203572,38.3759841 L94.5109416,1.4337996 C94.0364119,0.843411814 93.319802,0.5 92.5623482,0.5 Z"
                stroke="#373737"
                fill="#FFFFFF"
              />
              <text
                font-family="SegoeUI, Segoe UI"
                font-size="22"
                font-weight="normal"
                fill="#373737"
              >
                <tspan x="26.1064453" y="48">Volume</tspan>
              </text>
            </g>
          </g>
        </svg>
        <svg id="title-svg" viewBox="0 0 100 100">
          <g>
            <text
              class="title-text"
              x="0"
              y="48"
              font-family="SegoeUI, Segoe UI"
              font-size="10"
              font-weight="normal"
              fill="#00413B"
            >
              <tspan>Add Volume</tspan>
              <tspan x="0" dy="1.2em">Challenge Marker</tspan>
            </text>
          </g>
        </svg>
      </div>
      <div id="buttons">
        <svg id="buttons-desc" viewBox="0 0 5 2" preserveAspectRatio="xMinYMin">
          <text x="0" y="1.5" font-size="0.5">
            <tspan x="0.5" y="0.5">
              This will add a marker for a Volume Challenge
            </tspan>
            <tspan x="0.5" dy="0.7">at {{ time }} to the timeline</tspan>
          </text>
        </svg>
        <div id="ok-cancel">
          <button class="button" @click="clickOK">
            <svg viewBox="0 0 10 10" preserveAspectRatio="xMidYMid">
              <text x="3.5" y="2.4" font-size="2">OK</text>
            </svg>
          </button>
          <button class="button" @click="clickClose">
            <svg viewBox="0 0 10 10" preserveAspectRatio="xMidYMid">
              <text x="2" y="2.4" font-size="2">Cancel</text>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <svg id="close" viewBox="0 0 40 39" @click="clickClose">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g>
          <rect id="bg" fill="#00413B" x="0" y="0" width="100%" height="100%" />
          <polygon
            id="Path"
            fill="#FFFFFF"
            points="9 2 20.013 15.845 31.0275928 2 36.0275928 2 22.509 18.982 36.0275928 35.975305 31.0458031 35.975305 20.013 22.116 8.98178971 35.975305 4 35.975305 17.518 18.982 4 2"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { dialogClockMixin } from '@/components/DialogMixin'

export default {
  name: 'VolumeDialog',
  mixins: [dialogClockMixin],
  methods: {
    clickClose() {
      this.$emit('close-dialog')
    },
    clickOK() {
      this.$emit('add-marker', 'volume', 'Volume')
    }
  }
}
</script>

<style scoped>
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
#container {
  position: relative;
  background-color: white;
  border: 2px solid #00413b;
}

#close {
  position: absolute;
  width: 8%;
  height: 13%;
  top: 0;
  right: 0;
  background-color: #00413b;
}

#content {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#title {
  flex: 40%;
  max-height: 40%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#pressor-button {
  width: 25%;
  margin-left: 2%;
}

#title-svg {
  width: 70%;
  margin-left: 5%;
}

#buttons {
  flex: 32%;
  height: 32%;
  display: flex;
  flex-direction: column;
}

#buttons-desc {
  height: 60%;
  width: 92%;
  margin: 5% 5% 2% 6%;
  font-size: 1.2vw;
  text-align: left;
}

#ok-cancel {
  height: 30%;
  display: flex;
  justify-content: center;
  padding: 1%;
}
.button {
  border: none;
  background-color: #c4c4c4;
  width: 30%;
  height: 100%;
  box-sizing: border-box;
  margin-left: 4%;
  margin-right: 4%;
}
.button:focus {
  outline: none;
}
</style>
